import { useAuth } from "@/lib/auth";
import { Eye, X } from "lucide-react";
import { ROLE_LABEL } from "@/components/TeamUsersCard";

export default function ViewAsBanner() {
  const { isViewAs, user, actor, exitViewAs } = useAuth();
  if (!isViewAs || !user) return null;
  return (
    <div
      data-testid="view-as-banner"
      className="sticky top-14 z-40 bg-[#C9A961] text-[#0A1F44] border-b border-[#a4894f] shadow-sm"
    >
      <div className="max-w-6xl mx-auto px-4 py-2 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 min-w-0">
          <Eye className="w-4 h-4 shrink-0" />
          <span className="text-sm font-semibold truncate">
            Viewing as <span className="font-serif" data-testid="view-as-banner-name">{user.name}</span> — Read only
            <span className="hidden sm:inline text-[#0A1F44]/80"> · {ROLE_LABEL[user.role] || user.role}</span>
            {actor && (
              <span className="hidden md:inline text-[#0A1F44]/70"> · signed in as {actor.name}</span>
            )}
          </span>
        </div>
        <button
          data-testid="exit-view-as-btn"
          onClick={exitViewAs}
          className="inline-flex items-center gap-1.5 text-sm font-medium px-3 py-1.5 rounded-full bg-[#0A1F44] text-white hover:bg-[#0A1F44]/90"
        >
          <X className="w-4 h-4" /> Exit Preview
        </button>
      </div>
    </div>
  );
}
